'use client';

import { Search } from '@/components/home/Search';
import { IBackgroundImages } from '@/api/home/types';
import { Heading } from '@/components/ui/heading';
import { Text } from '@/components/ui/text';
import { Container } from '@/components/ui/container';
import { useOTSTranslation } from '@/i18n/useOTSTranslation';

interface IHero400Props {
  backgroundImage?: IBackgroundImages
  /**
   * Kept for API compatibility with resort/region callers that render
   * Hero400Error inline inside a content surface (light flow). In v3
   * both variants render the same neutral surface — no scrim, no
   * cover photo — so `light` no longer changes anything visible.
   */
  light?: boolean
}

// 400 / data-error surface. Same v3 chrome as Hero404; differs only
// by copy. Heading + Text tokens match the global landing pages so
// the page reads as one coherent product even when something has
// broken.

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const Hero400Error = (_props: IHero400Props) => {
  const { t } = useOTSTranslation('common');
  return (
    <Container as="section" width="xl-only" className="px-4 py-16 md:py-24">
      <div className="mx-auto max-w-2xl space-y-6 text-center">
        <Heading
          level={1}
        >
          {t('common.dataError')}
        </Heading>
        <Text variant="muted">
          {t('common.dataErrorBody')}
        </Text>
        <div className="pt-2">
          <Search />
        </div>
      </div>
    </Container>
  );
};
